import React, { Component } from 'react';
import Select, { components } from 'react-select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Autosuggest from 'react-autosuggest-ie11-compatible';
import { addFilter } from '../../utils';
import qs from 'qs';

import './style.css';

class SearchInput extends Component {
  getSiteFilter = () => {
    const { href } = window.location;
    const hashParams = href.substring(href.indexOf('?') + 1);
    const params = qs.parse(hashParams);
    const source =
      params &&
      params.filters &&
      params.filters.length > 0 &&
      JSON.parse(params.filters).source &&
      JSON.parse(params.filters).source[0];

    switch (this.props.app) {
      case 'ELSS':
        return 'e-LAB Solutions Suite';
      case 'OSS':
        return 'Online Store';
      case 'cap-web':
        return source || 'All Sites';
      default:
        return source || 'All Sites';
    }
  };

  getQ = () => {
    const hash = window.location.search;
    const { q } = qs.parse(hash.indexOf('?') === 0 ? hash.substring(1) : hash);
    return decodeURIComponent(q || '');
  };

  siteData = [
    'All Sites',
    'e-LAB Solutions Suite',
    'CAP Website',
    'Newsroom',
    'Education',
    'Online Store',
    'Foundation',
    'Annual Meeting',
  ];

  getSites = () =>
    this.siteData.map((sd) => ({
      key: sd,
      value: sd,
      text: sd,
      label: sd,
    }));

  getSiteObject = (text) => this.getSites().find((sd) => sd.text === text);

  _onChangeDropdown = (props) => {
    this.setState({
      ...this.state,
      siteSelected: props.value,
    });
  };

  inputRef = React.createRef();

  onChange = (e, data) => {
    if (data) {
      const value = data.newValue;
      this.setState({
        value,
      });
    }
  };

  onKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.target.blur();
      this.redirectSearch(e, encodeURIComponent(e.target.value));
    }
  };

  buildFilter = () => {
    const { href } = window.location;
    const hashParams = href.substring(href.indexOf('?') + 1);
    const params = qs.parse(hashParams);
    const filters = params.filters ? JSON.parse(params.filters) : {};
    if (this.props.app === 'ELSS') {
      if (!Array.isArray(filters.source)) {
        return addFilter('source', 'e-LAB Solutions Suite', '?');
      }
      return addFilter('source', filters.source[0], '?');
    }
    return addFilter('source', this.state.siteSelected, '?');
  };

  formatRedirect = (str) => (!str || str === '/' ? '' : str.replace(/^\/+|\/+$/g, ''));

  getRedirection = () => {
    const { redirectType, searchRedirect } = this.props;
    const formattedRedirect = this.formatRedirect(searchRedirect);

    if (redirectType === 'absolute') {
      return `${formattedRedirect}`;
    }
    return `${window.location.origin}${window.location.pathname.replace(/\/\s*$/, '')}${
      formattedRedirect ? '/' : ''
    }${formattedRedirect}`;
  };

  redirectSearch = (e, suggestion) => {
    const q = suggestion.suggestionValue;
    if (typeof suggestion === 'string') {
      window.location = `${this.getRedirection()}?q=${suggestion}${
        this.state.siteSelected !== 'All Sites' ? `&${this.buildFilter()}` : ''
      }`;
      return;
    } else {
      this.props.tAutocompleteSelection(
        suggestion.suggestion.id,
        suggestion.suggestion.title_raw,
        this.state.siteSelected,
      );
      window.location = `${this.getRedirection(true)}?q=${q}${
        this.state.siteSelected !== 'All Sites' ? `&${this.buildFilter()}` : ''
      }`;
    }
  };

  createDangerousMarkup = (text) => ({ __html: text });

  renderSuggestion = (suggestion) => {
    const suggestionText = suggestion.title_snippet;
    return (
      <div className='suggestion-item'>
        <span dangerouslySetInnerHTML={this.createDangerousMarkup(suggestionText)} />
      </div>
    );
  };

  onSuggestionsFetchRequested = ({ value }) => {
    if (this.props.app !== 'cap-web') {
      const { href } = window.location;
      const hashParams = href.substring(href.indexOf('?') + 1);
      const params = qs.parse(hashParams);
      const filters = params.filters ? JSON.parse(params.filters) : {};
      // If filter.source is not defined, use the default site to filter,
      // if is defined but empty, don't filter, if defined with values, use those values.
      const source = (() => {
        if (filters.source) {
          if (Array.isArray(filters.source) && filters.source.length > 0) {
            return filters.source;
          }
          return undefined;
        }
        return this.state.siteSelected;
      })();

      this.props.getSuggestion(value, source ? source : undefined);
      return;
    }
    if (this.state.value.length > 1) {
      this.props.getSuggestion(
        value,
        this.state.siteSelected === 'All Sites' ? undefined : this.state.siteSelected,
      );
    }
  };

  state = {
    value: this.getQ(),
    siteSelected: this.getSiteObject(this.getSiteFilter()).text,
  };

  render() {
    const sites = this.getSites();
    const source = this.getSiteObject(this.getSiteFilter());
    const inputProps = {
      placeholder: 'Search',
      value: this.state.value,
      ref: this.inputRef,
      onChange: this.onChange.bind(this),
      onKeyPress: this.onKeyPress.bind(this),
    };

    return (
      <div className={`search-input-wrapper ${this.props.app}`}>
        {this.props.app === 'cap-web' && (
          <Select
            defaultValue={source}
            options={sites}
            components={{ SingleValue }}
            isSearchable={false}
            isClearable={false}
            isMulti={false}
            onChange={this._onChangeDropdown.bind(this)}
            className='site-select'
            classNamePrefix='react-select'
          />
        )}
        <Autosuggest
          suggestions={this.props.suggestions}
          onSuggestionsFetchRequested={this.onSuggestionsFetchRequested.bind(this)}
          onSuggestionsClearRequested={this.props.clearSuggestions.bind(this)}
          renderSuggestion={this.renderSuggestion.bind(this)}
          getSuggestionValue={(suggestion) => (suggestion.title_raw ? suggestion.title_raw : '')}
          inputProps={inputProps}
          onSuggestionSelected={(e, suggestion) =>
            this.redirectSearch(e, suggestion, this.state.value)
          }
        />
        <div
          className='search-input-icon-wrapper'
          onClick={(e) => this.redirectSearch(e, this.state.value)}
        >
          <FontAwesomeIcon icon='search' />
        </div>
      </div>
    );
  }
}

const SingleValue = ({ children, ...props }) => {
  return <components.SingleValue {...props}>{children}</components.SingleValue>;
};

export default SearchInput;
